module.exports = __webpack_public_path__ + "img/SKWINKELNetActieCampagneplanning5FA7C4.06ca0b27.png";